import { ServerMessagesMapping } from '@core-models/messages/server-messages-mapping';

export const serverMessagesMapping: ServerMessagesMapping = {
    Restore_Customer_Not_Found: {
        code: 400,
        messageTranslationPath: 'FORGOT_PASSWORD.ERRORS.SERVER.CUSTOMER_NOT_FOUND',
        title: ''
    }
};